export class LiveViewProjectModeEntryModel {
    constructor() {
        this.projectId = "";
        this.projectName = "";
        this.teamId = "";
        this.projectCode = 0;
        this.liveTasksListForProject = [];
    }
}
export default class LiveViewProjectModeEntry extends LiveViewProjectModeEntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
